<script setup lang="ts">
  import { IconChevronUp } from '@gat-ship/icons'
  import {
    SelectScrollUpButton,
    type SelectScrollUpButtonProps,
    useForwardProps
  } from 'reka-ui'
  // fallow-ignore-next-line code-duplication
  import { computed, type HTMLAttributes } from 'vue'
  import { cn } from '../../../lib/utils'

  const props = defineProps<
    SelectScrollUpButtonProps & { class?: HTMLAttributes['class'] }
  >()

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
  })

  const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <SelectScrollUpButton
    data-slot="select-scroll-up-button"
    v-bind="forwardedProps"
    :class="
      cn('flex cursor-default items-center justify-center py-1', props.class)
    "
  >
    <slot>
      <icon-chevron-up class="size-4" />
    </slot>
  </SelectScrollUpButton>
</template>
